import moment from "moment-timezone";

const timezones = {
	"Pacific/Honolulu": {
		STD: "HST",
		DST: "HST",
	},
	"America/Anchorage": {
		STD: "AKST",
		DST: "AKDT",
	},
	"America/Los_Angeles": {
		STD: "PST",
		DST: "PDT",
	},
	"America/Boise": {
		STD: "MST",
		DST: "MDT",
	},
	"America/Denver": {
		STD: "MST",
		DST: "MDT",
	},
	"America/Chicago": {
		STD: "CST",
		DST: "CDT",
	},
	"America/New_York": {
		STD: "EST",
		DST: "EDT",
	},
	"Etc/GMT+10": {
		STD: "HST",
		DST: "HST",
	},
	"Etc/GMT+9": {
		STD: "AKST",
		DST: "AKDT",
	},
	"Etc/GMT+8": {
		STD: "PST",
		DST: "PDT",
	},
	"Etc/GMT+7": {
		STD: "MST",
		DST: "MDT",
	},
	"Etc/GMT+6": {
		STD: "CST",
		DST: "CDT",
	},
	"Etc/GMT+5": {
		STD: "EST",
		DST: "EDT",
	},
	"America/Phoenix": {
		STD: "MST",
		DST: "MST",
	},
};

export function getTimezoneName(timezone) {
	return timezone?.split("/")[1]?.replace("_", " ") || timezone;
}

export function getTimezoneAbbr(timezone, standard) {
	if (standard === undefined) {
		standard = moment.tz(new Date(), timezone).isDST();
	}

	const tz = timezones[timezone];
	if (standard) {
		return tz ? tz["STD"] : "STD";
	} else {
		return tz ? tz["DST"] : "DST";
	}
}

export function today() {
	return new Date().toISOString().split("T")[0];
}

export function last30() {
	return new Date(new Date().setDate(new Date().getDate() - 30))
		.toISOString()
		.split("T")[0];
}

export function last90() {
	return new Date(new Date().setDate(new Date().getDate() - 90))
		.toISOString()
		.split("T")[0];
}

export function formatDate(time) {
	const dateString = new Date(time).toLocaleString();
	const dateArray = dateString.split(/[,:/\s]+/g);
	return `${dateArray[0]}/${dateArray[1]}/${dateArray[2]}`;
}

export function formatDatetime(time) {
	const dateString = new Date(time).toLocaleString();
	const dateArray = dateString.split(/[,:/\s]+/g);
	return `${dateArray[3]}:${dateArray[4]} ${dateArray[6]}, ${dateArray[0]}/${dateArray[1]}/${dateArray[2]}`;
}

export function formatDatetimeWithLocalTimezone(time) {
	const tz = moment.tz.guess();
	const m = moment(time).tz(tz);

	return `${m.format("HH:mm")} ${m.zoneAbbr()}, ${m.format(
		"M/D/YYYY",
	)}`;
}

export function deTzTimestamp(datetime) {
	const mom = moment(datetime).utcOffset(0);
	const formatted = mom.format("YYYY-MM-DDTHH:mm");
	return formatted;
}

export function formatSiteLst(time, siteTimezone) {
	if (!time) return "";
	// Parse as UTC purely so the browser's zone (and its DST gaps) can never
	// shift the value. The string is a wall-clock time, so we format it as-is.
	const m = moment.utc(time);
	const abbr = getTimezoneAbbr(siteTimezone, true); // true = always standard time
	return `${m.format("HH:mm")} ${abbr}, ${m.format("M/D/YYYY")}`;
}

export function formatNowSiteLst(siteTimezone) {
	const y = new Date().getFullYear();
	// Standard offset = the smaller of the January and July offsets (excludes DST)
	const offsetMin = Math.min(
		moment.tz([y, 0, 1], siteTimezone).utcOffset(),
		moment.tz([y, 6, 1], siteTimezone).utcOffset()
	);
	const lst = moment.utc().add(offsetMin, "minutes");
	return formatSiteLst(lst.format("YYYY-MM-DDTHH:mm:ss"), siteTimezone);
}